export class EntityType {
  typeId
  type

  constructor(entityType = {}) {
    this.typeId = entityType.typeId ? String(entityType.typeId) : ''
    this.type = entityType.type ? String(entityType.type) : ''
  }
}